module.exports = __webpack_public_path__ + "watch.61c5325650877a758cba.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/ten/watch.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/ten/watch.jpg
// module chunks = 0